import { render, staticRenderFns } from "./r-authorize.vue?vue&type=template&id=06cb4c05"
import script from "./r-authorize.vue?vue&type=script&lang=js"
export * from "./r-authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cb4c05')) {
      api.createRecord('06cb4c05', component.options)
    } else {
      api.reload('06cb4c05', component.options)
    }
    module.hot.accept("./r-authorize.vue?vue&type=template&id=06cb4c05", function () {
      api.rerender('06cb4c05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/common/r-authorize.vue"
export default component.exports